export const mapRequiredProps = (league) => {
    league.id = league.id || "";
    league.sportId = league.sportId || "";
    league.name = league.name || "";
    return league;
};
//# sourceMappingURL=mapRequiredProps.js.map